const CRSLinesColumns = [
    { headerName: 'Customer No.', field: 'custNo' },
    { headerName: 'Charge Type', field: 'chargeType' },
    { headerName: 'Charge Code', field: 'chCode' },
    { headerName: 'Charge Period', field: 'chargePeriod' },
    { headerName: 'Description', field: 'desc' },
    { headerName: 'Country Code', field: 'countryCode' },
    { headerName: 'WW Code', field: 'wwCode' },
    { headerName: 'Partner Code', field: 'partnerCode' },
    { headerName: 'Reservation Number', field: 'resNo' },
    { headerName: 'Amount', field: 'amount' },
    { headerName: 'Brand Dimension Code', field: 'brand' },
    { headerName: 'Location Mnemonic', field: 'loc' },
    { headerName: 'Batch Ref. No.', field: 'batchRef' },
    { headerName: 'CL Indicator', field: 'clInd' },
    { headerName: 'Station Indicator', field: 'stInd' }
];

export default CRSLinesColumns;
  